<template>
    <NumberInput
        class="betslip-stake__input"
        id="stakeInput"
        autocomplete="off"
        :value="stake"
        @input="onInput"
        name="amount"
        :label="''"
    />
</template>

<script>
    export default {
        name: 'StakeInput',
        props: {
            stake: {
                type: Number,
                required: false,
            },
        },
        methods: {
            onInput(value) {
                this.$emit('stakeChanged', value);
            }
        },
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/shared/betSlip/StakeInput.vue